import { createStore } from "vuex";
import theme from "./modules/theme";
import dashboard from "./modules/dashboard";

export default createStore({
  modules: { theme, dashboard },
});
